import * as React from "react";
const SvgFiRrCupcakeAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cupcake-alt_svg__a)">
      <path
        fill="#062147"
        d="M23.982 11.142c-.166-1.647-1.567-2.96-3.267-3.125.232-.497.343-1.11.267-1.875C20.804 4.38 19.212 3 17.357 3h-1.591C15.14 1.853 14.124.63 12.855.122a1.7 1.7 0 0 0-1.514.125 1.76 1.76 0 0 0-.836 1.312A5.2 5.2 0 0 1 10.136 3H6.643C4.787 3 3.195 4.38 3.017 6.143a3.53 3.53 0 0 0 .327 1.87C1.618 8.15.184 9.475.017 11.142A3.5 3.5 0 0 0 2.63 14.89l.79 4.905A4.98 4.98 0 0 0 8.357 24h7.287a4.98 4.98 0 0 0 4.937-4.206l.79-4.905a3.5 3.5 0 0 0 1.726-1.04 3.52 3.52 0 0 0 .886-2.707zm-5.377 8.334A2.99 2.99 0 0 1 15.642 22H8.357a2.99 2.99 0 0 1-2.962-2.523L4.673 15h14.652zm3.006-6.97a1.48 1.48 0 0 1-1.09.493H3.478a1.48 1.48 0 0 1-1.091-.494 1.5 1.5 0 0 1-.38-1.164C2.083 10.588 2.802 10 3.643 10h8.356a1 1 0 1 0 0-2H6.5a1.48 1.48 0 0 1-1.111-.494 1.5 1.5 0 0 1-.38-1.164C5.083 5.588 5.802 5 6.643 5h4.103c.345 0 .665-.177.848-.469.4-.637.708-1.505.85-2.38.661.417 1.36 1.287 1.79 2.253a1 1 0 0 0 .914.595h2.21c.841 0 1.56.59 1.636 1.342.08.8-.093 1.218-1.366 1.73a1 1 0 0 0 .373 1.928h2.357c.841 0 1.56.59 1.636 1.342.043.433-.093.846-.38 1.164z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cupcake-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCupcakeAlt;
